import { configureStore } from '@reduxjs/toolkit';
import translationsReducer from './slices/translationsSlice';
import authReducer from './slices/authSlice';
import { api } from './slices/apiSlice'
import userProfileReducer from './slices/userProfileSlice';
import aiTranslationReducer from './slices/aiTranslationSlice';
import uiReducer from './slices/uiSlice';
import { toastMiddleware } from './middleware/toastMiddleware';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    translations: translationsReducer,
    userProfile: userProfileReducer,
    aiTranslation: aiTranslationReducer,
    ui: uiReducer,
  },
  middleware: (getDefault) => 
    getDefault()
      .concat(api.middleware)
      .concat(toastMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
